<p-dialog header="Pessoas processamentos - {{atributo}}: {{valor}}"
  [(visible)]="visivel"
  [closeOnEscape]="true"
  [modal]="true" [style]="{width: '94vw'}">
  <div class="p-fluid" style="height: 520px">

    <p-table
      [value]="ds.entidades"
      [totalRecords]="ds.total"
      (onLazyLoad)="onLazyLoad($event)"
      [loading]="carregando"
      [lazy]="true"
      [rows]="30"
      [paginator]="true"
      responsive="true"
      sortField="id"
      [scrollable]="true"
      scrollHeight="380px">
      <ng-template pTemplate="emptymessage">
        <tr><td>Nenhuma pessoa encontrada</td></tr>
      </ng-template>
      <ng-template pTemplate="caption">
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-lg-6">
            <input pInputText type="text" name="id" [(ngModel)]="id" placeholder="Id." (keyup)="onEnterSearch($event)" />
          </div>
          <div class="p-col-12 p-lg-6">
            <div class="p-inputgroup">
              <input pInputText type="text" name="erro" [(ngModel)]="erro" placeholder="Mensagem de erro" [disabled]="isHabilitadoFiltroErro()" (keyup)="onEnterSearch($event)" />
              <button pButton type="button" icon="pi pi-refresh" class="p-button-warn" [disabled]="isHabilitadoFiltroErro()" (click)="carregar()"></button>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="body" let-entidade>
        <tr>
          <td>
            <div class="p-grid">
              <div class="p-field p-col-12 p-md-12 text-left">
                <strong>Id: {{entidade.id}}</strong>
                <span *ngIf="entidade.sincronizada"> | <a pButton [routerLink]="['/pessoa/visualizar/', fonteDados.nome, entidade.id]" icon="pi pi-search" title="Visualizar a pessoa"></a></span>
              </div>
              <div class="p-field p-col-12 p-md-12 text-left">
                <div class="item-processamento">
                  <span class="item-processamento-titulo">Sincronização:</span>
                  <span class="label {{getSituacaoClasse(entidade.sincronizada ? 'PROCESSADO' : 'PENDENTE')}}">
                    {{getSituacaoDescricao(entidade.sincronizada ? 'PROCESSADO' : 'PENDENTE')}}
                  </span>
                </div>
                <div *ngIf="entidade.sincronizacaoData !== undefined">Processado em: {{entidade.sincronizacaoData | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-4 text-left">
                <div class="item-processamento">
                  <span class="item-processamento-titulo">Comunicação:</span>
                  <span *ngIf="isApresentarNumeroFalha (entidade.comunicacao.situacao) && (entidade.comunicacao.numeroFalhas > 0)">
                     <p-badge [value]="entidade.comunicacao.numeroFalhas < 10 ? '0' + entidade.comunicacao.numeroFalhas : entidade.comunicacao.numeroFalhas"
                              styleClass="p-badge-gray" pTooltip="Quantidade de Falhas Comunicação">
                     </p-badge> -
                 </span>
                  <span class="label {{getSituacaoClasse(entidade.comunicacao.situacao)}}">
                    {{getSituacaoDescricao(entidade.comunicacao.situacao)}}
                  </span>
                </div>
                <div *ngIf="entidade.comunicacao.situacao == 'PENDENTE'">Pendente desde: {{entidade.comunicacao.dataPendente | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                <div *ngIf="entidade.comunicacao.situacao == 'EXCLUIDO'">Excluído desde: {{entidade.comunicacao.dataPendente | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                <div>
                  <span  *ngIf="entidade.comunicacao.dataProcessamento !== undefined">{{ getRotuloDataProcessamento(entidade.comunicacao.situacao) }}</span>
                  {{ entidade.comunicacao.dataProcessamento | date: 'dd/MM/yyyy HH:mm:ss' }}
                </div>
                <div *ngIf="entidade.comunicacao.erro !== undefined" style="color: firebrick">Erro: {{entidade.comunicacao.erro}}</div>
              </div>
              <div class="p-field p-col-12 p-md-4 text-left">
                <div class="item-processamento">
                  <span class="item-processamento-titulo">Documentos:</span>
                  <span *ngIf="isApresentarNumeroFalha (entidade.ultimaAlteracaoDocumentos.situacao) && (entidade.ultimaAlteracaoDocumentos.numeroFalhas > 0)">
                    <p-badge [value]="entidade.ultimaAlteracaoDocumentos.numeroFalhas < 10 ? '0' + entidade.ultimaAlteracaoDocumentos.numeroFalhas : entidade.ultimaAlteracaoDocumentos.numeroFalhas"
                               styleClass="p-badge-gray" pTooltip="Quantidade de Falhas Documentos">
                    </p-badge> -
                 </span>
                  <span class="label {{getSituacaoClasse(entidade.ultimaAlteracaoDocumentos.situacao)}}">
                    {{getSituacaoDescricao(entidade.ultimaAlteracaoDocumentos.situacao)}}
                  </span>
                </div>
                <div *ngIf="entidade.comunicacao.situacao == 'PENDENTE'">Pendente desde: {{entidade.ultimaAlteracaoDocumentos.dataPendente | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                <div *ngIf="entidade.comunicacao.situacao == 'EXCLUIDO'">Excluído desde: {{entidade.ultimaAlteracaoDocumentos.dataPendente | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                <div>
                  <span  *ngIf="entidade.ultimaAlteracaoDocumentos.dataProcessamento !== undefined">{{ getRotuloDataProcessamento(entidade.ultimaAlteracaoDocumentos.situacao) }}</span>
                  {{ entidade.ultimaAlteracaoDocumentos.dataProcessamento | date: 'dd/MM/yyyy HH:mm:ss' }}
                </div>
                <div *ngIf="entidade.ultimaAlteracaoDocumentos.erro !== undefined" style="color: firebrick">Erro: {{entidade.ultimaAlteracaoDocumentos.erro}}</div>
              </div>
              <div class="p-field p-col-12 p-md-4 text-left">
                <div class="item-processamento">
                  <span class="item-processamento-titulo">Metadados:</span>
                  <span *ngIf="isApresentarNumeroFalha (entidade.ultimaAlteracaoMetadados.situacao) && (entidade.ultimaAlteracaoMetadados.numeroFalhas > 0)">
                    <p-badge [value]="entidade.ultimaAlteracaoMetadados.numeroFalhas < 10 ? '0' + entidade.ultimaAlteracaoMetadados.numeroFalhas : entidade.ultimaAlteracaoMetadados.numeroFalhas"
                             styleClass="p-badge-gray" pTooltip="Quantidade de Falhas Metadados">
                    </p-badge> -
                  </span>
                  <span class="label {{getSituacaoClasse(entidade.ultimaAlteracaoMetadados.situacao)}}">
                    {{getSituacaoDescricao(entidade.ultimaAlteracaoMetadados.situacao)}}
                  </span>
                </div>
                <div *ngIf="entidade.comunicacao.situacao == 'PENDENTE'">Pendente desde: {{entidade.ultimaAlteracaoMetadados.dataPendente | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                <div *ngIf="entidade.comunicacao.situacao == 'EXCLUIDO'">Excluído desde: {{entidade.ultimaAlteracaoMetadados.dataPendente | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                <div>
                  <span  *ngIf="entidade.ultimaAlteracaoMetadados.dataProcessamento !== undefined">{{ getRotuloDataProcessamento(entidade.ultimaAlteracaoMetadados.situacao) }}</span>
                  {{ entidade.ultimaAlteracaoMetadados.dataProcessamento | date: 'dd/MM/yyyy HH:mm:ss' }}
                </div>
                <div *ngIf="entidade.ultimaAlteracaoMetadados.erro !== undefined" style="color: firebrick">Erro: {{entidade.ultimaAlteracaoMetadados.erro}}</div>
              </div>
              <div class="p-field p-col-12 p-md-4 text-left">
                <div class="item-processamento">
                  <span class="item-processamento-titulo">Outros nomes:</span>
                  <span *ngIf="isApresentarNumeroFalha(entidade.ultimaAlteracaoOutrosNomes.situacao) && (entidade.ultimaAlteracaoOutrosNomes.numeroFalhas > 0)">
                    <p-badge [value]="entidade.ultimaAlteracaoOutrosNomes.numeroFalhas < 10 ? '0' + entidade.ultimaAlteracaoOutrosNomes.numeroFalhas : entidade.ultimaAlteracaoOutrosNomes.numeroFalhas"
                             styleClass="p-badge-gray" pTooltip="Quantidade de Falhas Outros Nomes">
                    </p-badge> -
                  </span>
                  <span class="label {{getSituacaoClasse(entidade.ultimaAlteracaoOutrosNomes.situacao)}}">
                      {{getSituacaoDescricao(entidade.ultimaAlteracaoOutrosNomes.situacao)}}
                  </span>
                </div>
                <div *ngIf="entidade.comunicacao.situacao == 'PENDENTE'">Pendente desde: {{entidade.ultimaAlteracaoOutrosNomes.dataPendente | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                <div *ngIf="entidade.comunicacao.situacao == 'EXCLUIDO'">Excluído  desde: {{entidade.ultimaAlteracaoOutrosNomes.dataPendente | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                <div>
                  <span  *ngIf="entidade.ultimaAlteracaoOutrosNomes.dataProcessamento !== undefined">{{ getRotuloDataProcessamento(entidade.ultimaAlteracaoOutrosNomes.situacao) }}</span>
                  {{ entidade.ultimaAlteracaoOutrosNomes.dataProcessamento | date: 'dd/MM/yyyy HH:mm:ss' }}
                </div>
                <div *ngIf="entidade.ultimaAlteracaoOutrosNomes.erro !== undefined" style="color: firebrick">Erro: {{entidade.ultimaAlteracaoOutrosNomes.erro}}</div>
              </div>
              <div class="p-field p-col-12 p-md-4 text-left">
                <div class="item-processamento">
                  <span class="item-processamento-titulo">Endereços:</span>
                  <span *ngIf="isApresentarNumeroFalha(entidade.ultimaAlteracaoEnderecos.situacao) && (entidade.ultimaAlteracaoEnderecos.numeroFalhas > 0)">
                    <p-badge [value]="entidade.ultimaAlteracaoEnderecos.numeroFalhas < 10 ? '0' + entidade.ultimaAlteracaoEnderecos.numeroFalhas : entidade.ultimaAlteracaoEnderecos.numeroFalhas"
                             styleClass="p-badge-gray" pTooltip="Quantidade de Falhas Endereços">
                    </p-badge> -
                  </span>
                  <span class="label {{getSituacaoClasse(entidade.ultimaAlteracaoEnderecos.situacao)}}">
                    {{getSituacaoDescricao(entidade.ultimaAlteracaoEnderecos.situacao)}}
                  </span>
                </div>
                <div *ngIf="entidade.comunicacao.situacao == 'PENDENTE'">Pendente desde: {{entidade.ultimaAlteracaoEnderecos.dataPendente | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                <div *ngIf="entidade.comunicacao.situacao == 'EXCLUIDO'">Excluído desde: {{entidade.ultimaAlteracaoEnderecos.dataPendente | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                <div>
                  <span  *ngIf="entidade.ultimaAlteracaoEnderecos.dataProcessamento !== undefined">{{ getRotuloDataProcessamento(entidade.ultimaAlteracaoEnderecos.situacao) }}</span>
                  {{ entidade.ultimaAlteracaoEnderecos.dataProcessamento | date: 'dd/MM/yyyy HH:mm:ss' }}
                </div>
                <div *ngIf="entidade.ultimaAlteracaoEnderecos.erro !== undefined" style="color: firebrick">Erro: {{entidade.ultimaAlteracaoEnderecos.erro}}</div>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>
